import React, { useState, useEffect } from 'react';
import moment from 'moment';

import * as Constants from '../../../requests/URLConstants';
import DashboardStackedBarChart from '../DashboardStackedBarChart';
import { queueTransactionTableHeaders, nonQueueTransactionTableHeaders } from './tableHeaders';
import * as DashboardUtils from '../DashboardUtils.js';
import DashboardSummary from '../DashboardSummaryNew';
import DashboardTable from "../DashboardTable";
import callPostApi from 'requests/PostRequests';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

export default function BusinessViewValueRealization(props) {
    const [summaryLoading, setSummaryLoading] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [trendingDataLoading, setTrendingDataLoading] = useState(false);
    const [trendingTransactionData, setTrendingTransactionData] = useState([]);
    const [nonQueueDataLoading, setNonQueueDataLoading] = useState(false);
    const [nonQueueTransactionData, setNonQueueTransactionData] = useState([]);
    const [queueDataLoading, setQueueDataLoading] = useState(false);
    const [queueTransactionData, setQueueTransactionData] = useState([]);
    let success = 0; let fail = 0;

    useEffect(() => {
        getQueueTransactionData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getNonQueueTransactionData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getSummaryData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getTransactionTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
                    "business_competencies": dashboardFilterSelectionsAutomation.competency,
                    "automata_state": dashboardFilterSelectionsAutomation.automata_state,
                    "automata_priority": dashboardFilterSelectionsAutomation.priority,
                    "status": dashboardFilterSelectionsAutomation.status,
                    "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
                    "bot_id": dashboardFilterSelectionsAutomation.bot_id,                   
                    "buisness_component": dashboardFilterSelectionsAutomation.buisness_component
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": timeFilterSelections.startDateTime,
                        "endDateTime": timeFilterSelections.endDateTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assigned_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }

        return bodyJSON;
    };
    const prepareNonQueueTransactionData = (resp) => {
        let tableObj = {};
        let tableData = [];
        let successful = 0; let failed = 0;
        if (resp) {
            let buckets = resp.aggregations.bot_id.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let botId = buckets[i];
                let leadPlatform = botId.lead_platform.buckets[0];
                let subArea = leadPlatform.sub_area.buckets[0];
                let processName = subArea.process_name.buckets[0];
                let geography = processName.geography.buckets[0];
                let processCriticality = geography.process_criticality.buckets[0];
                let requestedBy = processCriticality.requested_by.buckets[0];
                let deliveryModel = requestedBy.delivery_model.buckets[0];
                let businessMetricBuckets = deliveryModel.business_metric.buckets;
                for (let j = 0; j < businessMetricBuckets.length; j++) {
                    let businessMetric = businessMetricBuckets[j];
                    let status = businessMetric.status.buckets;
                    tableObj = {
                        id: ((i + 1).toString()) + Math.random(1),
                        botId: botId.key ? botId.key : 0,
                        leadPlatform: leadPlatform.key ? leadPlatform.key : 0,
                        subArea: subArea.key ? subArea.key : 0,
                        processName: processName.key ? processName.key : 0,
                        geography: geography.key ? geography.key : 0,
                        processCriticality: processCriticality.key ? processCriticality.key : 0,
                        requestedBy: requestedBy.key ? requestedBy.key : 0,
                        deliveryModel: deliveryModel.key ? deliveryModel.key : 0,
                        businessMetric: businessMetric.key ? businessMetric.key : 0,
                    };
                    for (let k = 0; k < status.length; k++) {
                        if (status[k].key === 'Successful') {
                            successful = status[k].doc_count;
                            tableObj.successful = successful;
                            tableObj.failed = "0";
                            success = success + successful
                        }
                        if (status[k].key === 'Failed') {
                            failed = status[k].doc_count;
                            tableObj.failed = failed;
                            tableObj.successful = "0";
                            fail = fail + failed;
                        }

                        //console.log(fail);
                    }
                    tableData.push(tableObj);
                }
            }
        }
        return tableData;
    }
    const prepareQueueTransactionData = (resp) => {
        let tableObj = {};
        let tableData = [];
        let completed = 0; let running = 0; let systemException = 0; let pending = 0; let deferred = 0;
        if (resp) {
            let buckets = resp.aggregations.bot_id.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let botId = buckets[i] ? buckets[i] : 0;
                let leadPlatform = botId.lead_platform.buckets[0];
                let subArea = leadPlatform.sub_area.buckets[0];
                let processName = subArea.process_name.buckets[0];
                let geography = processName.geography.buckets[0];
                let requestedBy = geography.requested_by.buckets[0];
                let deliveryModel = requestedBy.delivery_model.buckets[0];
                let supportStatus = deliveryModel.support_status.buckets[0];
                let businessMetricBuckets = supportStatus.business_metric.buckets;
                for (let j = 0; j < businessMetricBuckets.length; j++) {
                    let businessMetric = businessMetricBuckets[j];
                    let completions = businessMetric.completions.buckets;
                    tableObj = {
                        id: ((i + 1).toString()) + Math.random(1),
                        botId: botId.key ? botId.key : 0,
                        leadPlatform: leadPlatform.key ? leadPlatform.key : 0,
                        subArea: subArea.key ? subArea.key : 0,
                        processName: processName.key ? processName.key : 0,
                        geography: geography.key ? geography.key : 0,
                        requestedBy: requestedBy.key ? requestedBy.key : 0,
                        deliveryModel: deliveryModel.key ? deliveryModel.key : 0,
                        supportStatus: supportStatus.key ? supportStatus.key : 0,
                        businessMetric: businessMetric.key ? businessMetric.key : 0
                    }
                    for (let k = 0; k < completions.length; k++) {
                        if (completions[k].key === 'Completed') {
                            completed = completions[k].doc_count;
                            tableObj.completed = completed;
                        }
                        if (completions[k].key === 'Running') {
                            running = completions[k].doc_count;
                            tableObj.running = running;
                        }
                        if (completions[k].key === 'System Exception') {
                            systemException = completions[k].doc_count;
                            tableObj.systemException = systemException;
                        }
                        if (completions[k].key === 'Pending') {
                            pending = completions[k].doc_count;
                            tableObj.pending = pending;
                        }
                        if (completions[k].key === 'Deferred') {
                            deferred = completions[k].doc_count;
                            tableObj.deferred = deferred
                        }

                    }
                    tableData.push(tableObj);
                }

            }
        }
        //console.log(tableData);
        return tableData;
    }

    const prepareSummaryData = (resp) => {
        let total = resp.hits ? resp.hits.total : 0;
        let process = resp.aggregations ? resp.aggregations.process_number ? resp.aggregations.process_number.value : 0 : 0;
        let summary = [
            {
                title: DashboardConstants.Total,
                value: isNaN(total) ? 0 : total,
            },
            {
                title: DashboardConstants.Successful,
                value: isNaN(success) ? 0 : success,
            },
            {
                title: DashboardConstants.Failed,
                value: isNaN(fail) ? 0 : fail,
            },
            {
                title: DashboardConstants.ProcessNo,
                value: isNaN(process) ? 0 : process,
            },
        ];
        setSummaryData(summary);
    }

    const prepareTransactionTrendData = (resp) => {
        let buckets = resp.aggregations ? resp.aggregations["2"].buckets : 0;
        let stackedBarChartData = []; let stackedBarChartDataObj = {};
        for (let i = 1; i < buckets.length; i++) {
            let transactionBuckets = buckets[i]["3"].buckets;
            for (let j = 0; j < transactionBuckets.length; j++) {
                stackedBarChartDataObj = {
                    "group": transactionBuckets[j].key,
                    "key": `Process ${i}`,
                    "value": transactionBuckets[j] ? transactionBuckets[j].doc_count : 0
                }
                stackedBarChartData.push(stackedBarChartDataObj);
            }
        }
        //console.log(stackedBarChartData);
        setTrendingTransactionData(stackedBarChartData);
    }

    function getQueueTransactionData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setQueueDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETQUEUETRANSACTIONDETAILS, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareQueueTransactionData(resp);
                    setQueueTransactionData(formattedData);
                    setQueueDataLoading(false);
                })
                .catch((error) => {
                    setQueueDataLoading(false);
                });
        }
    }

    function getNonQueueTransactionData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setNonQueueDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETNONQUEUETRANSACTIONDETAILS, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    formattedData = prepareNonQueueTransactionData(resp);
                    setNonQueueTransactionData(formattedData);
                    setNonQueueDataLoading(false);
                })
                .catch((error) => {
                    setNonQueueDataLoading(false);
                });
        }
    }

    function getSummaryData(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setSummaryLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETPROCESSNUMBER, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    prepareSummaryData(resp);
                    setSummaryLoading(false);
                })
                .catch((error) => {
                    setSummaryLoading(false);
                });
        }
    }

    function getTransactionTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setTrendingDataLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETTRANSACTIONTRENDDETAILS, {
                "Content-Type": "application/json",
            }, bodyJSON)
                .then((resp) => {
                    prepareTransactionTrendData(resp);
                    setTrendingDataLoading(false);
                })
                .catch((error) => {
                    setTrendingDataLoading(false);
                });
        }
    }
    return (
        <div className="top-margin dashboard productive-metrics">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={summaryLoading}
                        summary={summaryData}
                        title={DashboardConstants.BusinessEntityTransactionsSummary}
                    />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                    <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div className="bar-chart" style={{ minWidth: '100%' }}>
                                <DashboardStackedBarChart
                                    loading={trendingDataLoading}
                                    title={DashboardConstants.Trending}
                                    graphAxesTitle={DashboardConstants.NoOfExecutions}
                                    graphBottomTitle={DashboardConstants.Processes}
                                    stackedBarChartData={trendingTransactionData}
                                />
                            </div>
                        </div>
                    </section>
                    <section classname="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.NonQueueTransactions}</div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={nonQueueDataLoading} rows={nonQueueTransactionData}
                                headers={nonQueueTransactionTableHeaders} showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                    <section classname="border-bottom">
                        <div className="graph-title carbon-display-Regular-20">
                            <div>{DashboardConstants.QueueTransactions}</div>
                        </div>
                        <div className="bold-border-table nested-table">
                            <DashboardTable loading={queueDataLoading} rows={queueTransactionData}
                                headers={queueTransactionTableHeaders} showPagination={true} isSortingAllowed={true} />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );

}